import { useQuery } from "@tanstack/react-query";

import { getById, listByCells, type StationDetail, type StationListItem } from "./api";

export function cellSetKey(cells: string[]): string {
  return [...cells].sort().join(",");
}

export function useStationsNearby(cellSet: string[], tag: string = "") {
  const sortedKey = cellSetKey(cellSet);
  const trimmedTag = tag.trim();
  return useQuery<StationListItem[]>({
    queryKey: ["stations", sortedKey, trimmedTag],
    queryFn: () => listByCells(cellSet, trimmedTag),
    enabled: cellSet.length > 0 || trimmedTag.length > 0,
    staleTime: 30_000,
  });
}

export function useStation(id: string | undefined) {
  return useQuery<StationDetail | null>({
    queryKey: ["station", id ?? ""],
    queryFn: () => getById(id!),
    enabled: !!id,
    staleTime: 30_000,
  });
}
